/**
 * Service da Agenda v2 (ADR-0090). Backend: app `tarefas`, views_agenda.
 *
 *   GET    /api/agenda/estado                       -> { liberada }
 *   GET    /api/agenda/inicio                       -> hoje, preferências, categorias...
 *   GET    /api/agenda/dados?de=&ate=               -> { tarefas, feriados, hoje, agora_min, versao }
 *   GET    /api/agenda/resumo                       -> { versao }  (atualização automática)
 *   GET    /api/agenda/ano?ano=                     -> { carga: {AAAA-MM-DD: minutos} }
 *   GET    /api/agenda/lista?filtro=                -> { tarefas }
 *   GET    /api/agenda/busca?q=                     -> { tarefas }
 *   GET    /api/agenda/tarefas?status=&prioridade=&... -> { itens, total, proximo_cursor } (Lista com filtros)
 *   POST   /api/agenda/lote                         body { ids, acao, valor } -> { desfazer_token, feitas, falhas }
 *   POST   /api/agenda/lote/desfazer                body { token }
 *   GET    /api/agenda/livres?de=&ate=&duracao=     -> { dias: [{ data, livres: [{inicio, fim, minutos}] }] }
 *   GET    /api/agenda/colegas                      -> { colegas: [{id, nome}] } (mesma unidade)
 *   POST   /api/agenda/tarefas                      -> { tarefa }
 *   GET    /api/agenda/tarefas/{id}                 -> { tarefa }  (detalhe)
 *   PATCH  /api/agenda/tarefas/{id}                 -> { tarefa }
 *   POST   /api/agenda/tarefas/{id}/{acao}          -> { tarefa }
 *   POST   /api/agenda/tarefas/{id}/subtarefas      -> { tarefa }
 *   POST   /api/agenda/tarefas/{id}/subtarefas/{sid}/marcar
 *   PATCH/DELETE .../subtarefas/{sid} ; POST .../subtarefas/ordem {ids} ; POST .../subtarefas/{sid}/converter
 *   POST   /api/agenda/tarefas/{id}/participantes ; PATCH/DELETE .../participantes/{usuario}
 *   PATCH/DELETE /api/agenda/tarefas/{id}/comentarios/{cid} (só os meus)
 *   POST/PATCH/DELETE /api/agenda/tarefas/{id}/apontamentos[/{aid}]  {inicio, fim} "AAAA-MM-DDTHH:MM"
 *   POST   /api/agenda/tarefas/{id}/subtarefas/{sid}/responsavel
 *   POST   /api/agenda/aviso-transparencia          (leu "a gestão pode ver a sua agenda")
 *   ?pessoa=<id> em dados, resumo e tarefa: agenda de outra pessoa (só leitura)
 *   POST   /api/agenda/tarefas/{id}/comentarios
 *   POST   /api/agenda/tarefas/{id}/vinculos ; DELETE ?tipo=&referencia=
 *   POST   /api/agenda/ordem                        body { tarefas: [ids] }
 *   GET/POST /api/agenda/categorias ; PATCH/DELETE /api/agenda/categorias/{id}
 *   GET/PATCH /api/agenda/preferencias ; GET/PATCH /api/agenda/configuracao
 *   GET    /api/agenda/sistema?atualizar=1          -> { itens }
 *   POST   /api/agenda/sistema/planejar             body { item_id, data?, rota? }
 *   POST   /api/agenda/ocorrencias                  body { id: "<série>:<dia>" } -> { tarefa } (a ocorrência vira linha)
 *   GET    /api/agenda/relatorio?data=              -> { texto, concluidas, em_andamento, pendentes }
 *   POST   /api/agenda/de-pendencia                 body { pendencia_id, data? } (Central)
 *   GET    /api/agenda/do-pedido?pedido=&pendencias= -> { tarefas, pendencias_na_agenda }
 *   POST   /api/agenda/tarefas/{id}/anexos (multipart, ou JSON {url, nome} = link) ; GET/DELETE .../anexos/{aid}
 *   GET/POST/PATCH/DELETE /api/agenda/assinatura  (link .ics; o link sai só no POST)
 *   GET    /api/agenda/calendarios               -> { google: {...}, caldav: {...} } (ADR-0093)
 *   POST   /api/agenda/google/conectar           -> { url } (Google) ; POST .../google/retorno { codigo, estado }
 *   POST   /api/agenda/google/sincronizar ; DELETE /api/agenda/google
 *   POST/DELETE /api/agenda/caldav/senha          (a senha sai só no POST)
 *
 * Datas trafegam como "AAAA-MM-DD" e horas como minutos desde 00:00.
 */

const BASE = "/api/agenda";

function json(metodo, corpo) {
  return { method: metodo, body: JSON.stringify(corpo || {}) };
}

function query(params) {
  const busca = new URLSearchParams();
  Object.entries(params || {}).forEach(([chave, valor]) => {
    if (valor !== undefined && valor !== null && valor !== "") busca.set(chave, valor);
  });
  const texto = busca.toString();
  return texto ? `?${texto}` : "";
}

export const lerEstado = (request) => request(`${BASE}/estado`, { silentError: true });
export const lerInicio = (request) => request(`${BASE}/inicio`);
/** `pessoa`: agenda de outra pessoa da unidade (agenda:ver_equipe, só leitura). */
export const lerDados = (request, de, ate, opcoes = {}, pessoa = null) =>
  request(`${BASE}/dados${query({ de, ate, pessoa })}`, opcoes);
export const lerResumo = (request, pessoa = null) => request(`${BASE}/resumo${query({ pessoa })}`, { silentError: true });
export const lerAno = (request, ano) => request(`${BASE}/ano${query({ ano })}`);
export const lerLista = (request, filtro) => request(`${BASE}/lista${query({ filtro })}`);
export const buscar = (request, q) => request(`${BASE}/busca${query({ q })}`, { silentError: true });
/** A Lista com filtros do servidor; `filtros` já no formato da query (listas viram "a,b"). */
export const listarTarefas = (request, filtros) => request(`${BASE}/tarefas${query(filtros)}`);
export const aplicarLote = (request, ids, acao, valor) => request(`${BASE}/lote`, json("POST", { ids, acao, valor }));
export const desfazerLote = (request, token) => request(`${BASE}/lote/desfazer`, json("POST", { token }));
export const lerHorariosLivres = (request, de, ate, duracao) =>
  request(`${BASE}/livres${query({ de, ate, duracao })}`, { silentError: true });
export const lerColegas = (request) => request(`${BASE}/colegas`, { silentError: true });

export const criarTarefa = (request, dados) => request(`${BASE}/tarefas`, json("POST", dados));
export const lerTarefa = (request, id, pessoa = null) => request(`${BASE}/tarefas/${id}${query({ pessoa })}`);
export const editarTarefa = (request, id, dados, opcoes = {}) =>
  request(`${BASE}/tarefas/${id}`, { ...json("PATCH", dados), ...opcoes });
export const agir = (request, id, acao, corpo, opcoes = {}) =>
  request(`${BASE}/tarefas/${id}/${acao}`, { ...json("POST", corpo), ...opcoes });

export const criarSubtarefa = (request, id, titulo) =>
  request(`${BASE}/tarefas/${id}/subtarefas`, json("POST", { titulo }));
export const marcarSubtarefa = (request, id, subtarefaId, feita) =>
  request(`${BASE}/tarefas/${id}/subtarefas/${subtarefaId}/marcar`, json("POST", { feita }));
/** `dados`: { titulo?, prazo? } ("AAAA-MM-DD" ou null). */
export const editarSubtarefa = (request, id, subtarefaId, dados) =>
  request(`${BASE}/tarefas/${id}/subtarefas/${subtarefaId}`, json("PATCH", dados));
export const removerSubtarefa = (request, id, subtarefaId) =>
  request(`${BASE}/tarefas/${id}/subtarefas/${subtarefaId}`, { method: "DELETE" });
export const ordenarSubtarefas = (request, id, ids) =>
  request(`${BASE}/tarefas/${id}/subtarefas/ordem`, json("POST", { ids }));
/** A subtarefa vira tarefa: responde { tarefa } com a tarefa nova. */
export const converterSubtarefa = (request, id, subtarefaId) =>
  request(`${BASE}/tarefas/${id}/subtarefas/${subtarefaId}/converter`, json("POST"));
export const incluirParticipante = (request, id, usuarioId) =>
  request(`${BASE}/tarefas/${id}/participantes`, json("POST", { usuario_id: usuarioId }));
/** `permissao`: "VER" | "COMENTAR" | "EDITAR" (só o dono). */
export const mudarPermissao = (request, id, usuarioId, permissao) =>
  request(`${BASE}/tarefas/${id}/participantes/${usuarioId}`, json("PATCH", { permissao }));
export const removerParticipante = (request, id, usuarioId) =>
  request(`${BASE}/tarefas/${id}/participantes/${usuarioId}`, { method: "DELETE" });
export const atribuirSubtarefa = (request, id, subtarefaId, responsavelId) =>
  request(`${BASE}/tarefas/${id}/subtarefas/${subtarefaId}/responsavel`, json("POST", { responsavel_id: responsavelId || null }));
export const comentar = (request, id, texto) =>
  request(`${BASE}/tarefas/${id}/comentarios`, json("POST", { texto }));
export const editarComentario = (request, id, comentarioId, texto) =>
  request(`${BASE}/tarefas/${id}/comentarios/${comentarioId}`, json("PATCH", { texto }));
export const excluirComentario = (request, id, comentarioId) =>
  request(`${BASE}/tarefas/${id}/comentarios/${comentarioId}`, { method: "DELETE" });
/** `periodo`: { inicio, fim } em "AAAA-MM-DDTHH:MM" (fuso da pessoa). */
export const criarApontamento = (request, id, periodo) =>
  request(`${BASE}/tarefas/${id}/apontamentos`, json("POST", periodo));
export const editarApontamento = (request, id, apontamentoId, periodo) =>
  request(`${BASE}/tarefas/${id}/apontamentos/${apontamentoId}`, json("PATCH", periodo));
export const removerApontamento = (request, id, apontamentoId) =>
  request(`${BASE}/tarefas/${id}/apontamentos/${apontamentoId}`, { method: "DELETE" });
export const vincular = (request, id, vinculo) =>
  request(`${BASE}/tarefas/${id}/vinculos`, json("POST", vinculo));
export const desvincular = (request, id, tipo, referencia) =>
  request(`${BASE}/tarefas/${id}/vinculos${query({ tipo, referencia })}`, { method: "DELETE" });

export const ordenar = (request, ids) => request(`${BASE}/ordem`, json("POST", { tarefas: ids }));

/** { categorias (inclui as arquivadas), icones: [{valor, rotulo}] }. */
export const lerCategorias = (request) => request(`${BASE}/categorias`);
export const criarCategoria = (request, dados) => request(`${BASE}/categorias`, json("POST", dados));
export const editarCategoria = (request, id, dados) =>
  request(`${BASE}/categorias/${id}`, json("PATCH", dados));
export const excluirCategoria = (request, id) =>
  request(`${BASE}/categorias/${id}`, { method: "DELETE" });

export const lerPreferencias = (request) => request(`${BASE}/preferencias`);
export const salvarPreferencias = (request, dados) => request(`${BASE}/preferencias`, json("PATCH", dados));
export const marcarAvisoDeTransparencia = (request) => request(`${BASE}/aviso-transparencia`, json("POST"));
export const marcarConviteDeConexoes = (request) => request(`${BASE}/convite-conexoes`, { ...json("POST"), silentError: true });
export const lerConfiguracao = (request) => request(`${BASE}/configuracao`);
export const salvarConfiguracao = (request, dados) => request(`${BASE}/configuracao`, json("PATCH", dados));

export const lerSistema = (request, atualizar = false) =>
  request(`${BASE}/sistema${query({ atualizar: atualizar ? "1" : "" })}`, { silentError: true });
export const planejar = (request, itemId, dados = {}) =>
  request(`${BASE}/sistema/planejar`, json("POST", { item_id: itemId, ...dados }));

// ---------- Fase 5 ----------

/** Ocorrência ainda virtual de uma série: "<série>:<AAAA-MM-DD>". */
export function separarOcorrencia(id) {
  const partes = String(id || "").split(":");
  return partes.length === 2 && /^\d{4}-\d{2}-\d{2}$/.test(partes[1]) ? { serie: partes[0], dia: partes[1] } : null;
}
export const materializarOcorrencia = (request, id) => request(`${BASE}/ocorrencias`, json("POST", { id }));
export const lerRelatorio = (request, data) => request(`${BASE}/relatorio${query({ data })}`);
export const tarefaDaPendencia = (request, pendenciaId, data) =>
  request(`${BASE}/de-pendencia`, json("POST", { pendencia_id: pendenciaId, data }));
export const lerTarefasDoPedido = (request, pedido, pendencias = []) =>
  request(`${BASE}/do-pedido${query({ pedido, pendencias: pendencias.join(",") })}`, { silentError: true });
export function anexar(request, id, arquivo) {
  const corpo = new FormData();
  corpo.append("arquivo", arquivo);
  return request(`${BASE}/tarefas/${id}/anexos`, { method: "POST", body: corpo });
}
export const anexarLink = (request, id, url, nome) =>
  request(`${BASE}/tarefas/${id}/anexos`, json("POST", { url, nome }));
export const removerAnexo = (request, id, anexoId) =>
  request(`${BASE}/tarefas/${id}/anexos/${anexoId}`, { method: "DELETE" });
export const caminhoDoAnexo = (id, anexoId) => `${BASE}/tarefas/${id}/anexos/${anexoId}`;

// ---------- Fase 6: assinatura .ics (ADR-0092) ----------
export const lerAssinatura = (request) => request(`${BASE}/assinatura`, { silentError: true });
export const gerarAssinatura = (request) => request(`${BASE}/assinatura`, json("POST"));
export const salvarFiltrosDaAssinatura = (request, filtros) => request(`${BASE}/assinatura`, json("PATCH", filtros));
export const desligarAssinatura = (request) => request(`${BASE}/assinatura`, { method: "DELETE" });

// ---------- Fase 7: Google Agenda e CalDAV de duas vias (ADR-0093) ----------
export const lerCalendarios = (request) => request(`${BASE}/calendarios`, { silentError: true });
export const iniciarGoogle = (request) => request(`${BASE}/google/conectar`, json("POST"));
export const concluirGoogle = (request, codigo, estado) =>
  request(`${BASE}/google/retorno`, { ...json("POST", { codigo, estado }), silentError: true });
export const sincronizarGoogle = (request) => request(`${BASE}/google/sincronizar`, json("POST"));
export const desconectarGoogle = (request) => request(`${BASE}/google`, { method: "DELETE" });
export const gerarSenhaCalDAV = (request) => request(`${BASE}/caldav/senha`, json("POST"));
export const desligarCalDAV = (request) => request(`${BASE}/caldav/senha`, { method: "DELETE" });

